// extracted by mini-css-extract-plugin
export default {"errorContainer":"display-error_errorContainer__qRxZQ","shake":"display-error_shake__arGW0","errorShake":"display-error_errorShake__OP2Rt","inner":"display-error_inner__kHUXi"};